module.exports = __webpack_public_path__ + "static/assets/aff9524c78dd205f02a614937102c5ee.gif";